import React from 'react'
import styled from 'styled-components'

const Svg = styled.svg`
  transition: all 400ms;
`

export default ({ color }) => (
  <Svg width="65" height="25" viewBox="0 0 65 25" xmlns="http://www.w3.org/2000/svg">
    <g fill={color || '#fff'} fillRule="evenodd">
      <path d="M18.009 21.414c0 .587-1.04 1.206-3.715 1.206-2.676 0-2.453.002-3.776.002-3.936 0-4.473-3.947-4.473-6.816 0-2.445.126-6.52 5.131-6.52h4.03c1.04 0 2.803 0 2.803 1.173v10.955zM22.432.154h-2.897l.003.004h-.145c-.85 0-1.384.782-1.384 1.498v4.468c0 .684-.095.912-.598.88-.504-.033-4.062-.098-7.43-.098C.408 6.906 0 12.056 0 15.904 0 23.435 3.62 25 13.034 25c9.413 0 10.783-1.565 10.783-2.837V1.654c0-.717-.535-1.5-1.385-1.5zM41.5 22.662c-4.538-.015-6.283-.901-6.283-6.95 0-6.057 2.399-6.43 6.283-6.435v-.134.134c3.884.005 6.283.378 6.283 6.434 0 6.05-1.744 6.936-6.283 6.95M41.505 7v.052V7C34.656 7 28.969 7.698 29 16.076c0 8.535 6.748 8.922 12.476 8.923V25l.024-.001.024.001v-.001C47.252 24.998 54 24.611 54 16.076 54.03 7.698 48.354 7 41.505 7"
      />
      <path d="M45 16.116c0-2.712-.833-3.11-3-3.116-2.167.007-3 .404-3 3.116 0 2.715 1.145 2.882 3 2.884 1.855-.002 3-.17 3-2.884M63.552 24h-3.104c-.8 0-1.448-.645-1.448-1.441V1.44C59 .645 59.648 0 60.448 0h3.104C64.352 0 65 .645 65 1.441V22.56c0 .796-.648 1.441-1.448 1.441"
      />
    </g>
  </Svg>
);


// WEBPACK FOOTER //
// ./src/ui/components/generic/LogoSmall.js